module.exports = __webpack_public_path__ + "static/media/website_icon.2e885663.svg";